import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { propertyListApi } from "../../apis/propertylisting/propertyListApi";

export const fetchPropertyList = createAsyncThunk(
  "fetchPropertyList",
  async ({
    keyword,
    propertyType,
    type,
    location,
    bedroom,
    bathroom,
    amenities,
    area_sqft,
    isFeatured,
    page
  }) => {
    try {
      const response = await propertyListApi(
        keyword,
        propertyType,
        type,
        location,
        bedroom,
        bathroom,
        amenities,
        area_sqft,
        isFeatured,
        page
      );

      return response?.data?.data;
    } catch (error) {
      return null;
    }
  }
);

const productListSlice = createSlice({
  name: "propertyList",
  initialState: {
    isLoading: false,
    data: [],
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPropertyList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchPropertyList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });

    builder.addCase(fetchPropertyList.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
    });
  },
});

export default productListSlice.reducer;
